export default {
  ctaSuccessTitle: {
    id: 'product_card_add_to_cart_toast_title',
    defaultMessage: 'Added to cart',
  },
} as const
